export const jobLevels = ['Individual contributor', 'Manager', 'Director', 'SVP/VP', 'C-level', 'Other'];
